export const ORDERED_REQUIREMENT_KEYS = [
  'needsPalletExchange',
  'sealable',
  'codeXl',
  'topLoading',
  'sideLoading',
  'dockLoading',
  'directTransfer',
  'arrivalNotification'
]

/** Helper function to return a list that contains the translation keys of all requirements (with truthy value) of the given order. */
export function generateRequirementsList(order) {
  return ORDERED_REQUIREMENT_KEYS.reduce((requirementsList, requirementKey) => {
    if (order && order[requirementKey])
      requirementsList.push(`myTransports.requirements.${requirementKey}`)
    return requirementsList
  }, [])
}

export function generateFormattedRequirements(requirements, fullList = false) {
  if (!requirements || !requirements.length) {
    return ['-']
  }
  const { length } = requirements
  const byPattern = fullList ? length : 2
  const formattedList = requirements.slice(0, byPattern).map(key => this.$t(key))
  if (length > byPattern) {
    formattedList[1] = `${formattedList[1]} ${this.$tc(
      'myTransports.transportRow.requirements.items',
      length - 2,
      length - 2
    )}`
  }
  return formattedList
}
